export default __webpack_public_path__ + "static/media/25092702.a7b5ef3f.jpg";